import styled from 'styled-components'

export const FormGroup = styled.div`
  margin-bottom: ${props => props.marginBottom || '1rem'};
`
